const abcdkColumnsOrder = {
  Analytique: 10,
  Pragmatique: 20,
  "Émotivo-Relationnel": 30,
  "Visuo-Imaginatif": 40,
  Kinesthesique: 50,
};

export default abcdkColumnsOrder;
